var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "box", class: _vm.btnClasses }, [
    _c("div", { staticClass: "boxInner" }, [
      _vm.theImage
        ? _c("div", {
            staticClass: "img",
            class: { isKiosk: true },
            style: { backgroundImage: 'url("' + _vm.theImage + '")' },
          })
        : _vm._e(),
      _vm.anyIcon
        ? _c(
            "div",
            { staticClass: "text-center mt-3" },
            [
              _vm.icon
                ? _c(
                    "v-icon",
                    {
                      staticClass: "myWhite buttonIcon iconSpace",
                      attrs: { dark: "" },
                    },
                    [_vm._v(_vm._s("" + _vm.icon))]
                  )
                : _vm._e(),
              _vm.svg
                ? _c("img", {
                    staticClass: "imgIcon iconSpace",
                    attrs: { src: _vm.svgSource },
                  })
                : _vm._e(),
              _vm.pngicon
                ? _c("img", {
                    staticClass: "imgIcon iconSpace",
                    class: { soloInvert: _vm.inverse },
                    attrs: { src: _vm.pngSource },
                  })
                : _vm._e(),
              _vm.rastericon
                ? _c("img", {
                    staticClass: "imgIcon iconSpace",
                    attrs: { src: _vm.rasterSource },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "bottom d-flex align-center",
          class: { center: _vm.anyIcon },
        },
        [
          _c(
            "h3",
            {
              staticClass: "flex-grow-1 mobile customPadding titleFont",
              class: {
                oneLiner:
                  _vm.nomargin && _vm.$store.getters.deviceClass.includes("xs"),
              },
            },
            [_vm._v(_vm._s(_vm.theLabel))]
          ),
          _c(
            "h3",
            {
              staticClass:
                "flex-grow-1 tablet text-truncate customPadding titleFont",
            },
            [_vm._v(_vm._s(_vm.theLabel))]
          ),
          !_vm.anyIcon
            ? _c(
                "div",
                { staticClass: "text-right align-self-center" },
                [
                  _c("v-icon", { staticClass: "myAccent" }, [
                    _vm._v("mdi-chevron-right"),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _vm.anyIcon ? _c("div", { staticClass: "mb-1" }) : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }